import type React from 'react';
import { StoreSelectionLink } from '../storelocator/StoreDetails';
import * as style from './StoreInfoActions.module.css';

export interface Props {
    name: string;
}

export default function StoreInfoActions({ name, children }: React.PropsWithChildren<Props>) {
    return (
        <div className={style.storeInfoActions}>
            {children}
            <StoreSelectionLink name={name} />
        </div>
    );
}
